var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', {
    staticClass: "text-primary"
  }, [_vm._v("折價券兌換")]), _c('h2', [_vm._v("實體通路選擇")]), _c('div', {
    staticClass: "p-4"
  }, [_c('p', {
    staticClass: "text-left"
  }, [_vm._v(" 2022/04/01-2022/12/30，至指定合作實體通路，購買好奇裸感好動褲(M-XXL)，單箱／包即可立即折扺$50元 ")]), _c('div', {
    staticClass: "d-flex flex-nowrap justify-content-between"
  }, [_c('b-form-select', {
    staticClass: "mr-3",
    attrs: {
      "size": "lg"
    },
    model: {
      value: _vm.selectArea,
      callback: function callback($$v) {
        _vm.selectArea = $$v;
      },
      expression: "selectArea"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null
    }
  }, [_vm._v(" 請選擇區域 ")]), _vm._l(_vm.parentBranches, function (parentBranch) {
    return _c('b-form-select-option', {
      key: parentBranch.id,
      attrs: {
        "value": parentBranch.id
      }
    }, [_vm._v(" " + _vm._s(parentBranch.name) + " ")]);
  })], 2), _c('b-form-select', {
    attrs: {
      "size": "lg"
    },
    model: {
      value: _vm.selectBranch,
      callback: function callback($$v) {
        _vm.selectBranch = $$v;
      },
      expression: "selectBranch"
    }
  }, [_vm.childBranches.length === 0 ? _c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v(" 請先選擇區域 ")]) : _vm._e(), _vm._l(_vm.childBranches, function (childBranch) {
    return _c('b-form-select-option', {
      key: childBranch.id,
      attrs: {
        "value": childBranch.id
      }
    }, [_vm._v(" " + _vm._s(childBranch.name) + " ")]);
  })], 2)], 1), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-confirm",
      modifiers: {
        "modal-confirm": true
      }
    }],
    staticClass: "button my-4"
  }, [_c('span', {
    staticClass: "h4 mb-0 font-weight-bold"
  }, [_vm._v("確認送出")]), _c('span', {
    staticClass: "h5 mb-0 font-weight-bold text-primary"
  }, [_vm._v("（請臨櫃結帳時再按送出）")])]), _c('router-link', {
    staticClass: "button my-4 d-inline-block w-auto",
    attrs: {
      "to": {
        name: 'LiffHuggiesCoupons'
      }
    }
  }, [_c('span', {
    staticClass: "h5 mb-0 font-weight-bold text-primary"
  }, [_vm._v("返回上一頁")])]), _c('b-modal', {
    attrs: {
      "id": "modal-confirm",
      "size": "sm",
      "hide-footer": "",
      "hide-header": "",
      "centered": ""
    }
  }, [_c('div', {
    staticClass: "p-2"
  }, [_c('p', {
    staticClass: "my-4 text-center"
  }, [_vm._v(" 您確定要兌換折價券嗎？ "), _c('br'), _vm._v("點選確認後30分鐘內臨櫃使用 ")]), _c('div', {
    staticClass: "d-flex"
  }, [_c('button', {
    staticClass: "button mr-3",
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modal-confirm');
      }
    }
  }, [_c('span', {
    staticClass: "h4 mb-0 font-weight-bold text-primary"
  }, [_vm._v("取消")])]), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.submitRedeem
    }
  }, [_c('span', {
    staticClass: "h4 mb-0 font-weight-bold text-primary"
  }, [_vm._v("確定使用")])])])])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }